import { jsx as _jsx } from "react/jsx-runtime";
var ArrowBottom = function ArrowBottom(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 32 32",
    children: /*#__PURE__*/_jsx("path", {
      fill: !ignoreColor ? color : undefined,
      d: "M16.05 20.45 3.25 7.6c-.75-.75-1.95-.75-2.7 0C.2 7.95 0 8.4 0 8.9s.2 1 .55 1.35l14.1 14.15c.7.75 1.9.75 2.65.05l.05-.05 14.1-14.15c.35-.35.55-.85.55-1.35A1.9 1.9 0 0 0 30.1 7c-.5 0-1 .2-1.35.55l-12.7 12.9z"
    })
  });
};
export default ArrowBottom;